import React, {useEffect, useState} from 'react';
import Breadcrumbs from '../Components/Breadcrumbs';
import Table from '../Components/Tables';
import {ConfirmationProvider, useConfirmation} from '../Components/ConfirmationContext';
import {AlertProvider, useAlert} from '../Components/AlertContext';
import {formatDateUTC} from '../utils/formatDateUTC';

import {useNavigate, useParams} from "react-router-dom";
import {ConnectionObjectApiProvider, useConnectionObjectApi} from "../Services/ConnectionObjectApiProvider";
import Button from "../Components/Buttons";

function ConnectionObjectHub({canEdit}) {
  const {getConnectionObjects, deleteConnectionObject} = useConnectionObjectApi();
  const {organizationId} = useParams();
  const { showAlert } = useAlert();
  const { showConfirmation } = useConfirmation();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [connectionObjects, setConnectionObjects] = useState([]);
  const [totalConnectionObjects, setTotalConnectionObjects] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const navigate = useNavigate();


  const columns = [
    {name: 'ID', selector: (row) => row.id, sortable: true},
    {name: 'Name', selector: (row) => row.name, sortable: true},
    {name: 'Type', selector: (row) => row.type, sortable: true},
    {name: 'Active', selector: (row) => row.is_active ? 'Active' : 'Inactive', sortable: true},
    {name: 'Created', selector: (row) => formatDateUTC(row.created_at), sortable: true},
    {name: 'Updated', selector: (row) => formatDateUTC(row.updated_at), sortable: true},
  ];

  const fetchConnectionObjects = async (skip, limit) => {
    if (limit !== itemsPerPage) {
      setItemsPerPage(limit);
    }
    try {

      setLoading(true);
      const response = await getConnectionObjects(skip, limit);
      setConnectionObjects(response.items);
      setTotalConnectionObjects(response.totalCount);
      setItemsPerPage(limit);
    } catch (error) {
      console.error("Error fetching connection objects:", error);
      setError("Failed to load connection objects");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchConnectionObjects(0, itemsPerPage);
  }, []);

  const handleRowClicked = (row) => {
    navigate(`/organizations/${organizationId}/connection-objects/${row.id}`);
  };

    const handleDelete = async (selectedId) => {
    if (!selectedId) return;
    showConfirmation(
        `Are you sure you want to delete the selected Connection Object?`,
        async () => {
            try {
              setLoading(true);
              await deleteConnectionObject(selectedId);
              fetchConnectionObjects(0, itemsPerPage);
              showAlert('success', 'Connection Object was successfully deleted!');
            } catch (error) {
              showAlert('fail', 'Failed to delete the connection object!');
            }
        }
    );
  };


  return (
    <div className="container">
      <Breadcrumbs/>
      <div className="row d-flex gap">
        <div className="radius-yes p-2 bg-yes col-12">
          {error ? (
            <div>Error: {error}</div>
          ) : (
            <>
              <Table
                title="Connection Objects"
                columns={columns}
                data={connectionObjects}
                selectableRowsHighlight
                selectableRows
                progressPending={loading}
                paginationPerPage={itemsPerPage}
                onRowClicked={handleRowClicked}
                onDelete={handleDelete}
                paginationTotalRows={totalConnectionObjects}
                sortIcon={<i className="fa-solid fa-chevron-down"></i>}
                onChangePage={fetchConnectionObjects}
              />
              {canEdit &&(
                <Button
                  background="color2"
                  size="large"
                  onClick={() => navigate(`/organizations/${organizationId}/connection-objects/new-connection-object`)}
                >
                  Create New Connection Object
                </Button>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

function ConnectionObjectHubWrapper({canEdit}) {
  return (
    <AlertProvider>
      <ConfirmationProvider>
        <ConnectionObjectApiProvider>
          <ConnectionObjectHub canEdit={canEdit}/>
        </ConnectionObjectApiProvider>
      </ConfirmationProvider>
    </AlertProvider>
  );
}

export default ConnectionObjectHubWrapper;
